export const ROUTES = [
    {
        path: "/",
        name: "首頁",
        id: "home",
    },
    {
        path: "/schedule",
        name: "班級課表",
        id: "class-schedule",
    },
    {
        path: "/simulator",
        name: "排課模擬器",
        id: "class-simulation",
    },
    {
        path: "/calendar",
        name: "行事曆",
        id: "calendar",
    },
    {
        path: "/standards",
        name: "課程標準",
        id: "standards",
    },
    {
        path: "/course/:id",
        name: "課程詳細資訊",
        id: "course-detail",
        hideInNav: true,
    },
];